// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--WHFHpe19Nz8GTAfZ"};